import siteConfig from "@iso/config/site.config";
import { getPostRequestInfo, getRequestGeneratorFunction } from "@iso/utils/connectUtils";
import { put } from "redux-saga/effects";
import { DATA_TYPES } from "src/infinode/constants/data";
import { ANALYSIS_TYPES } from "src/infinode/constants/data";
import dataUrls from "src/infinode/constants/urls/dataUrls";
import actions from "./actions";

const getEnergyUrl = dataRequestPayload => {
  let result = "";
  if (
    !dataRequestPayload.circuitId &&
    !dataRequestPayload.circuitCategoriesLevel1 &&
    !dataRequestPayload.circuitCategoriesLevel2
  ) {
    result = dataRequestPayload.zoneId ? dataUrls.getZoneSummary : dataUrls.getSiteSummary;
  } else {
    result = dataUrls.getCircuits;
  }
  return result;
};


const getCostUrl = dataRequestPayload => {
  let result = "";
  // console.log(`getcosturl`);
  // console.log(dataRequestPayload.circuitId);
  // console.log(dataRequestPayload.circuitCategoriesLevel1);
  // console.log(dataRequestPayload.circuitCategoriesLevel2);
  if (
    !dataRequestPayload.circuitId &&
    !dataRequestPayload.circuitCategoriesLevel1 &&
    !dataRequestPayload.circuitCategoriesLevel2
  ) {
    // console.log(`here`);
    result = dataRequestPayload.zoneId ? dataUrls.getZoneCostSummary : dataUrls.getSiteCostSummary;
  } else {
    result = dataUrls.getCircuitsCost;
  }
  return result;
};
const getPowerUrl = dataRequestPayload => {
  let result = "";
  // console.log(`getenergyurl`);
  // console.log(dataRequestPayload.circuitId);
  // console.log(dataRequestPayload.circuitCategoriesLevel1);
  // console.log(dataRequestPayload.circuitCategoriesLevel2);

  if (
    !dataRequestPayload.circuitId &&
    !dataRequestPayload.circuitCategoriesLevel1 &&
    !dataRequestPayload.circuitCategoriesLevel2
  ) {
    result = dataRequestPayload.zoneId ? dataUrls.getZonePowerSummary : dataUrls.getSitePowerSummary;
  } else {
    result = dataUrls.getCircuitsPower;
  }
  return result;
};
const getDemandUrl = () => {
  return dataUrls.getDemand;
};

const getRealtimeUrl = () => {
  return dataUrls.getRealtime;
};

const getTrendAnalysisUrl = dataRequestPayload => {
  let result = "";
  if (
    !dataRequestPayload.circuitId &&
    !dataRequestPayload.circuitCategoriesLevel1 &&
    !dataRequestPayload.circuitCategoriesLevel2
  ) {
    result = dataRequestPayload.zoneId ? dataUrls.getZoneTrendAnalysisSummary : dataUrls.getSiteTrendAnalysisSummary;
  } else {
    result = dataUrls.getCircuitsTrendAnalysis;
  }
  return result;
};

const getAnomalyDetectionUrl = dataRequestPayload => {
  let result = "";
  if (
    !dataRequestPayload.circuitId &&
    !dataRequestPayload.circuitCategoriesLevel1 &&
    !dataRequestPayload.circuitCategoriesLevel2
  ) {
    result = dataRequestPayload.zoneId ? dataUrls.getZoneAnomalyDetectionSummary : dataUrls.getSiteAnomalyDetectionSummary;
  } else {
    result = dataUrls.getCircuitsAnomalyDetection;
  }
  return result;
};

const getUrl = (dataRequestPayload, dataType) => {
  let url = "";
  console.log('here');
  switch (dataType) {
    case DATA_TYPES.ENERGY:
      url = getEnergyUrl(dataRequestPayload);
      break;
    case DATA_TYPES.COST:
      url = getCostUrl(dataRequestPayload);
      break;    
    case DATA_TYPES.POWER:
      url = getPowerUrl(dataRequestPayload);
      break;
    case DATA_TYPES.DEMAND:
      url = getDemandUrl(dataRequestPayload);
      break;
    case DATA_TYPES.REALTIME:
      url = getRealtimeUrl(dataRequestPayload);
      break;
    case ANALYSIS_TYPES.TREND_ANALYSIS:
      // console.log('here');
      url = getTrendAnalysisUrl(dataRequestPayload);
      break
    case ANALYSIS_TYPES.ANOMALY_DETECTION:
      url = getAnomalyDetectionUrl(dataRequestPayload);
      break;
    default:
      break;
  }
  return url;
};

// Fix the property values for server request format
const fixEnergyRequestPayload = payload => {
  if (payload.circuitCategoriesLevel1 && payload.circuitCategoriesLevel1.length === 0) {
    payload.circuitCategoriesLevel1 = null;
  }
  if (payload.circuitCategoriesLevel2 && payload.circuitCategoriesLevel2.length === 0) {
    payload.circuitCategoriesLevel2 = null;
  }
  return payload;
};

const fixRequestPayload = (dataRequestPayload, dataType) => {
  let payload = dataRequestPayload;
  switch (dataType) {
    case DATA_TYPES.ENERGY:
      payload = fixEnergyRequestPayload(dataRequestPayload);
      break;
    case DATA_TYPES.COST:
      payload = fixEnergyRequestPayload(dataRequestPayload);
      break;
    case DATA_TYPES.POWER:
        payload = fixEnergyRequestPayload(dataRequestPayload);
        break;
    case DATA_TYPES.DEMAND:
      payload = fixEnergyRequestPayload(dataRequestPayload);
      break;
    case DATA_TYPES.REALTIME:
      break;
    case ANALYSIS_TYPES.TREND_ANALYSIS:
      payload = fixEnergyRequestPayload(dataRequestPayload);
      break;
    case ANALYSIS_TYPES.ANOMALY_DETECTION:
      payload = fixEnergyRequestPayload(dataRequestPayload);
      break;
    default:
      break;
  }
  return payload;
};

const onGetDataRequest = ({ token, dataRequestPayload, dataType }) => {
  // console.log('onGetDataRequest');
  const fixedPayload = fixRequestPayload(dataRequestPayload, dataType);
  return fetch(`${siteConfig.apiUrl}${getUrl(fixedPayload, dataType)}`, getPostRequestInfo(fixedPayload, token)).then(
    response => response
  );
};

const onGetDataSuccess = function* (resultBody, params) {
  if (resultBody.dataItems !== undefined) {
    yield put({
      type: actions.GET_DATA_SUCCESS,
      dataItems: resultBody.dataItems,
      isCurrentData: params.isCurrentData,
      dataRequestPayload: params.dataRequestPayload,
      dataType: params.dataType
    });
    return true;
  }
  return false;
};

const getDataRequest = getRequestGeneratorFunction(
  actions.GET_DATA_REQUEST,
  actions.DATA_ERROR,
  onGetDataRequest,
  onGetDataSuccess
);

export default {
  getDataRequest
};
